<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/notification/details/', projectId, jobId, notificationId]">Zurück zur Mitteilung</a>
    </li>
  </ul>
</nav>

<main>
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Mitteilung {{ projectId }}.0007.{{ notificationId }} bearbeiten</h2>
  <app-notification-form
    *ngIf="notificationData"
    (save)="updateNotification($event)"
    [projectId]="projectId"
    [jobId]="jobId"
    [notificationId]="notificationId"
    [notificationData]="notificationData"
    [isUpdateMode]="true">
  </app-notification-form>
</main>

<pre *ngIf="devMode" class="datepicker-output">
    {{ notificationData | json }}
</pre>
